
<div class="flex justify-content-between py-4">
    <span class="flex justify-content-center w-full cursor-pointer">
        <a href="https://lincsell.com/" target="_blank"><img  src="assets/images/LincSell-Main.svg" width="150px" alt="Lincsell"></a>
    </span>
    <span class="flex justify-content-end px-4">
        <i (click)="cancel()"  class="pi pi-times text-4xl p-1 mx-4 cursor-pointer"></i>
    </span>
</div>

<div class="flex justify-content-center mx-4 p-4 py-4">
    <div class="sm:w-10 md:w-8 lg:w-7 lx:w-5" >

        <div class="text-lg text-500 font-medium flex justify-content-center mb-4">
        <span class="w-10 lg:w-8 lx:w-5">
                <div class="flex justify-content-between">
                    <div class="flex">
                        <div class="pb-4">
                            Step 1 of 3
                        </div>
                    </div>
                    <!-- <div class="flex" *ngIf="_signup.accountVerified">
                        <div class="pb-4">
                            <a href="javascript:void(0)" title="logout" (click)="logout()">
                                <i class="mb-4 pi pi-power-off text-2xl text-success"></i></a>
                        </div>
                    </div> -->
                </div>


                <span class="flex justify-content-between">
                    <a
                    *ngIf="_signup.accountVerified"
                    (click)="redirect()"
                    title="forward to Plan and Billing"
                    class="details-link cursor-pointer back-link"
                    ><i
                        class="pi pi-arrow-circle-right text-3xl text-primary"
                    ></i>
                </a>
                    <strong class="text-900 cursor-pointer flex align-items-center" >
                        <img src="assets/icons/checked.svg" *ngIf="_signup.accountVerified" class="pr-2" />
                        Personal Information
                    </strong>
                    <i class="pi pi-angle-right"></i>
                    <span (click)="redirect()" [ngClass]="{'cursor-pointer' :_signup.accountVerified}">Plan and Billing</span>
                            <i class="pi pi-angle-right"></i>
                    <span>Checkout</span>
                </span>
        </span>

        </div>

        <form [formGroup]="editform" autocomplete="off">


        <div class="grid mt-2 w-full">
            <div  class="col-12 md:col-6 lg:col-6 xl:col-6 ml-0 pl-0">
                <label class="control-label font-medium">
                    First Name
                    <span style="color: red; font-size: 1.25rem">*</span>
                </label>
                    <input  style="width: 100%" type="text" pInputText placeholder=""
                    name="firstName"
                    [formControl]="$any(editform.controls)['firstName']"
                    class="mt-2"
                    [disabled]="_signup.accountVerified || _signup.userAccountPendingForPayment"
                    (input)="_signup?.personalInfo.firstName = $event.target.value"
                    [ngClass]="{'shipping-address-disabled':_signup.accountVerified, 'ng-dirty ng-invalid': f.firstName.invalid && f.firstName.touched}"

                    />
                    <div *ngIf="f.firstName?.touched">
                        <div *ngIf="f.firstName.errors?.required " class="invalid-feedback"
                            style="margin-top: 7px">
                            This field is required.
                        </div>
                        <div *ngIf="f.firstName.errors?.pattern " class="invalid-feedback"
                            style="margin-top: 7px">
                            First name is not valid.
                        </div>
                    </div>
                    </div>
            <div  class="col-12 md:col-6 lg:col-6 xl:col-6">
                <label class="control-label font-medium">
                    Last Name
                    <span style="color: red; font-size: 1.25rem">*</span>
                </label>
                <!-- <app-text-input [formControl]="$any(editform.controls)['lastName']" [name]="'Last Name'"
                    [label]="''" style="width:100%" (input)="_signup?.personalInfo.lastName = $event.target.value"></app-text-input> -->
                    <input  style="width: 100%" type="text" pInputText placeholder=""
                    name="lastName"
                    [ngClass]="{'shipping-address-disabled':_signup.accountVerified, 'ng-dirty ng-invalid': f.lastName.invalid && f.lastName.touched}"
                    [disabled]="_signup.accountVerified || _signup.userAccountPendingForPayment"
                    [formControl]="$any(editform.controls)['lastName']"
                    class="mt-2"
                    (input)="_signup?.personalInfo.lastName = $event.target.value" />
                    <div *ngIf="f.lastName?.touched">
                        <div *ngIf="f.lastName.errors?.required " class="invalid-feedback"
                            style="margin-top: 7px">
                            This field is required.
                        </div>
                        <div *ngIf="f.lastName.errors?.pattern " class="invalid-feedback"
                            style="margin-top: 7px">
                            Last name is not valid.
                        </div>
                    </div>
                    </div>
        </div>

        <div class="grid mt-2 w-full">
            <div class="col-12 md:col-6 lg:col-6 xl:col-6 pl-0 ml-0" *ngIf="!_signup.userAccountPendingForPayment">
                <label class="control-label font-medium">
                    Email
                    <span style="
                                color: red;
                                font-size: 1.25rem;
                                margin-bottom: 7px; ;
                            ">*</span>
                </label>
                <div class="form-group mt-2">
                    <input  style="width: 100%" type="text" pInputText placeholder=""
                        name="email"
                        [disabled]="_signup.accountVerified || _signup.userAccountPendingForPayment"
                        [ngClass]="{'shipping-address-disabled':_signup.accountVerified}"
                        [formControl]="$any(editform.controls)['email']"
                        (input)="_signup?.personalInfo.email = $event.target.value" />
                        <span class="control-description text-muted" > This is your primary email. It can't be changed later. </span>
                        </div>
                <div *ngIf="f.email?.touched && !_signup.userAccountPendingForPayment">
                    <div *ngIf="f.email.errors?.required" class="invalid-feedback"
                        style="margin-top: 7px">
                        This field is required.
                    </div>
                    <div *ngIf="f.email.errors?.userexist" class="invalid-feedback"
                        style="margin-top: 7px">
                        Email already exists.
                    </div>
                    <div *ngIf="f.email.errors?.emailStrength"
                        class="invalid-feedback" style="margin-top: 7px">
                        Email is not valid.
                    </div>
                </div>
            </div>
            <div class="col-12 md:col-6 lg:col-6 xl:col-6 " *ngIf="!_signup.userAccountPendingForPayment">
                <label class="control-label font-medium">
                    Confirm Email
                    <span style="
                                color: red;
                                font-size: 1.25rem;
                                margin-bottom: 7px; ;
                            ">*</span>
                </label>
                <div class="form-group mt-2">
                    <input #email id="personal-info-confirm-email" style="width: 100%" type="text" pInputText placeholder=""
                        name="confirm email" [disabled]="_signup.accountVerified || _signup.userAccountPendingForPayment"
                        [ngClass]="{'ng-dirty ng-invalid': f.confirmEmail.invalid && f.confirmEmail.touched}"
                        [disabled]="_signup.accountVerified || _signup.userAccountPendingForPayment || _signup.accountVerified"
                        [ngClass]="{'shipping-address-disabled':_signup.accountVerified}"
                        [formControl]="$any(editform.controls)['confirmEmail']"
                        (input)="_signup?.personalInfo.confirmEmail = $event.target.value" />
                </div>
                <div *ngIf="f.confirmEmail.touched && f.confirmEmail.invalid && !_signup.userAccountPendingForPayment && !_signup.accountVerified"
                class="invalid-feedback">
                <div class="invalid-feedback" *ngIf="f.confirmEmail.errors?.required" style="margin-top: 7px">
                    This field is required.
                </div>
                <div class="invalid-feedback" *ngIf="f.confirmEmail.errors?.mismatchEmail" style="margin-top: 7px">
                Confirm email didn't match.
                </div>
            </div>
            </div>
        </div>
        <div class="grid mt-2 w-full">
            <div class="col-12 md:col-6 lg:col-6 xl:col-6 pl-0 ml-0">
                <label class="control-label font-medium">
                    Business Name
                        <span style="color: red; font-size: 1.25rem">*</span>
                    </label
                >
                <br />
                <input
                    style="width: 100%; margin-top: 7px"
                    type="text"
                    pInputText
                    placeholder=""
                    [ngClass]="{'ng-dirty ng-invalid': f.businessName.invalid && f.businessName.touched}"
                    [formControl]="$any(editform.controls)['businessName']"
                    [name]="'Business Name'"
                    [disabled]="_signup.accountVerified || _signup.userAccountPendingForPayment || _signup.accountVerified "
                    [ngClass]="{'shipping-address-disabled':_signup.accountVerified}"
                    (input)="
                        _signup?.businessInfo.companyName = $event.target.value
                    "
                />
                <span class="control-description text-muted" > The business name should be unique. It can't be changed later. </span>
                <div *ngIf="f.businessName.touched && !_signup.accountVerified">
                    <div
                        *ngIf="f.businessName.errors?.required"
                        class="invalid-feedback"
                        style="margin-top: 7px"
                    >
                    This field is required.
                    </div>
                    <div
                        *ngIf="f.businessName.errors?.companyexist"
                        class="invalid-feedback"
                        style="margin-top: 7px"
                    >
                    Business name already exists.
                    </div>
                </div>
            </div>
            <div class="col-12 md:col-6 lg:col-6 xl:col-6">
                <label class="control-label font-medium">
                    Phone
                    <span style="color: red; font-size: 1.25rem">*</span>
                </label>
                <!-- <div class="p-inputgroup mt-2 mb-2"> -->
                        <!-- <app-phone-input style="width:100%" placeholder=""
                            [formControl]="$any(editform.controls)['phone']" (keyup)="inputPersonalInfoPhone($event)">
                        </app-phone-input> -->
                        <div class="p-inputgroup" [style]="{ width: '100%' }">
                            <span class="p-inputgroup-addon"
                                ><img src="assets/images/us-flag-icon.png" style="width: 25px"
                            /></span>
                            <p-inputMask #maskInput
                                [style]="{ 'width': '100%' }"
                                mask="(999) 999-9999"
                                [formControl]="$any(editform.controls)['phone']"
                                placeholder=" "
                                [autoClear]="false"
                                class="w-full mt-2"

                                (click)="moveCursorToStart(maskInput)"
                            >
                            </p-inputMask>
                        </div>
                        <div *ngIf="f.phone.touched && !_signup.accountVerified">
                                <div
                                    *ngIf="f.phone.errors?.required"
                                    class="invalid-feedback"
                                    style="margin-top: 7px"
                                >
                                This field is required.
                                </div>
                                <div
                                    *ngIf="f.phone.errors?.pattern"
                                    class="invalid-feedback"
                                    style="margin-top: 7px"
                                >
                                Phone number is not valid.
                                </div>
                            </div>
                <!-- </div> -->
            </div>
        </div>

        <div class="grid mt-2 w-full" *ngIf="!_signup.userAccountPendingForPayment && !_signup.accountVerified">
            <div class="w-full">
                <label class="control-label font-medium">
                    Password
                    <span style="color: red; font-size: 1.25rem">*</span>
                <img src="../../../../assets/images/info.svg" pTooltip="Password must contain a combination of uppercase & lowercase letters, numbers, and special characters !#$%&*." class="px-2" alt="Info">
                </label>
                <p-password id="password" [formControl]="editform.controls['password']" placeholder=""
                    [toggleMask]="true" [feedback]="true" autocomplete="new-password"
                    [style]="{ width: '100%', 'margin-top': '8px' }" [inputStyle]="{ width: '100%' }"
                    styleClass="w-full mb-5 p-password p-component p-inputwrapper p-input-icon-right"
                    (input)="_signup?.personalInfo.password = $event.target.value"
                    [strongRegex]="passwordValidatorString"
                    >
                    <ng-template pTemplate="footer" >
                        <p-divider></p-divider>
                        <p class="mt-2" *ngIf="f.password.invalid">Suggestions</p>
                        <!-- <ul class="pl-2 ml-2 mt-0" style="line-height: 1.5">
                            <li>This field is required</li>
                            <li>At least one lowercase</li>
                            <li>At least one uppercase</li>
                            <li>At least one numeric</li>
                            <li>At least one special character</li>
                            <li>Between 8 and 16 characters</li>
                        </ul> -->
                        <ul class="pl-2 ml-2 mt-0" style="line-height: 1.5">
                            <li *ngIf="f.password.errors?.required">This field is required</li>
                            <li *ngIf="f.password.errors?.lowercase">At least one lowercase</li>
                            <li *ngIf="f.password.errors?.uppercase">At least one uppercase</li>
                            <li *ngIf="f.password.errors?.digit">At least one numeric</li>
                            <li *ngIf="f.password.errors?.specialCharacter">At least one special character</li>
                            <li *ngIf="f.password.errors?.length">Between 8 and 16 characters</li>
                        </ul>
                    </ng-template>
                </p-password>
                <div *ngIf="f.password.touched && f.password.invalid && !_signup.userAccountPendingForPayment"
                    class="invalid-feedback">
                    <div class="invalid-feedback" *ngIf="
                            f.password.errors?.required" style="margin-top: -20px">
                        This field is required.
                    </div>

                    <div class="invalid-feedback" *ngIf="f.password.errors?.lowercase || f.password.errors?.uppercase || f.password.errors?.specialCharacter || f.password.errors?.digit || f.password.errors?.length" style="margin-top: -20px">
                        Password should contain <ng-container *ngIf="f.password.errors?.length">between 8 and 16 characters,</ng-container> <ng-container *ngIf="f.password.errors?.uppercase"> an uppercase letter,</ng-container> <ng-container *ngIf="f.password.errors?.lowercase">a lowercase letter,</ng-container>  <ng-container *ngIf="f.password.errors?.digit">a numeric digit,</ng-container> <ng-container *ngIf="f.password.errors?.specialCharacter"> a special character</ng-container>
                    </div>
                </div>
            </div>
        </div>

        </form>
        <br />
        <div class="grid" *ngIf="!_signup.accountVerified">
            <div class="sm:col-12 md:col-12 lg:col-12 xl:col-12">
                <p class="text-lg text-left" style="margin: 0px">
                    By clicking "Next: Plan and Billing", you agree to our <strong (click)="showTerms()" class="cursor-pointer underline">Terms of Service</strong>  & <strong (click)="showEndUserAggreement()" class="cursor-pointer underline">Privacy Policy</strong>.
                </p>
            </div>
        </div>

        <div class="flex align-items-center justify-content-center" [ngClass]="{'disabled':!editform?.valid }" *ngIf="!_signup.accountVerified">
            <span (click)="saveFn()" [disabled]="!editform?.valid" class="cursor-pointer next-btn">
                Next: Plan and Billing
            </span>
        </div>

    </div>
</div>



